import React from 'react';

import { I18n } from 'components/translate';

export default class DescriptionImport extends React.PureComponent {
  render() {
    return (
      <div className="description__import">
        <p className="secondary mt__md">
          <I18n label="users_import.import_description.first" />
        </p>

        <p className="secondary mb__md">
          <I18n label="users_import.import_description.second" />
        </p>
      </div>
    );
  }
}
